import { render, staticRenderFns } from "./ArticleVersionsSidebar.vue?vue&type=template&id=2b771f71&"
import script from "./ArticleVersionsSidebar.vue?vue&type=script&lang=ts&"
export * from "./ArticleVersionsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleVersionsSidebar.vue?vue&type=style&index=0&id=2b771f71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports